import { render } from "./TvmFeatureTiles.vue?vue&type=template&id=3e340526&scoped=true"
import script from "./TvmFeatureTiles.vue?vue&type=script&lang=js"
export * from "./TvmFeatureTiles.vue?vue&type=script&lang=js"

import "./TvmFeatureTiles.vue?vue&type=style&index=0&id=3e340526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e340526"],['__file',"src/Components/ChatWidget/TvmFlowEndItems/TvmFeatureTiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e340526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e340526', __exports__)) {
    api.reload('3e340526', __exports__)
  }
  
  module.hot.accept("./TvmFeatureTiles.vue?vue&type=template&id=3e340526&scoped=true", () => {
    api.rerender('3e340526', render)
  })

}


export default __exports__